(function () {
  if (window.location.pathname.indexOf('/products/nourkrin-inclinic') === -1) {
    return;
  }

  function setSubscriptionLabel() {
    var span = document.querySelector(
      'label[for="appstle_selling_plan_label_20"] .appstle_subscribe_save_text'
    );
    if (span && span.textContent.trim() !== 'Subskrypcja') {
      span.textContent = 'Subskrypcja';
    }
  }

  setSubscriptionLabel();

  var observer = new MutationObserver(setSubscriptionLabel);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();